import { RuntimeRepository } from "core/repository";
import BaseService from "core/service/base.service";

class Base2Presenter {
  static router = null;

  constructor(props) {
    this._props = props;
    this._changeListener = null;
    this._viewModel = this.initialState();
    this.subscriptions = [];
    this._earlyStart();
  }

  initialState() {
    return {};
  }

  get viewModel() {
    return this._viewModel;
  }

  async _earlyStart() {
    this.mRuntime = await RuntimeRepository.getInstance();

    if (this.controlApiRequests()) {
      this.mCancelToken = BaseService.getNewCancelToken();
    }

    this.onStart();
  }

  async onStart() {
    // TO BE OVERRIDEN
  }

  async onEnd() {
    this.subscriptions.forEach(({ event, subscriptionId }) =>
      this.mRuntime.unsubscribe(event, subscriptionId)
    );
    if (this.controlApiRequests() && this.mCancelToken) {
      this.mCancelToken.cancel();
    }
  }

  renewCancelToken() {
    if (!this.controlApiRequests()) {
      return;
    }

    if (this.mCancelToken) {
      this.mCancelToken.cancel();
    }

    this.mCancelToken = BaseService.getNewCancelToken();
  }

  controlApiRequests() {
    return true;
  }

  get props() {
    return this._props;
  }

  get router() {
    return Base2Presenter.router;
  }

  get route() {
    return this.router.stateService.current;
  }

  get routeParams() {
    return this.router.stateService.params;
  }

  enqueue(stateChange, callback = () => {}) {
    return new Promise(resolve => {
      if (this._changeListener) {
        this._changeListener(stateChange, async viewModel => {
          this._viewModel = viewModel;
          await callback();
          resolve();
        });
      }
    });
  }

  onChangeProps() {
    // DO NOTHING
  }

  async navigateTo(state, params = {}, options = {}) {
    this.router.stateService.go(state, params, options);
  }

  subscribeTo(event, callback) {
    const subscriptionId = this.mRuntime.subscribe(event, callback);
    this.subscriptions.push({ event, subscriptionId });
  }

  sendNotification(options) {
    this.mRuntime.fire(RuntimeRepository.props.notification, options);
  }
}

export default Base2Presenter;



// WEBPACK FOOTER //
// ./src/core/presenter/base2.presenter.js